module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.apiMode === 'production') { 
    ; __append(" <h3>Production Webhooks</h3> <p><a class=\"btn btn-blue btn-block create_webhook\" href=\"#\">Create Production Webhook</a></p> ")
    ;  } else { 
    ; __append(" <h3>Test Webhooks</h3> <p><a class=\"btn btn-blue btn-block create_webhook\" href=\"#\">Create Test Webhook</a></p> ")
    ;  } 
    ; __append(" <ul> ")
    ;  if(locals.webhooks.length == 0) { 
    ; __append(" <li class=\"no_results\"> No webhooks are registered for ")
    ; __append(escapeFn( locals.apiMode ))
    ; __append(". </li> ")
    ;  } else { 
    ; __append(" ")
    ;  _.each(locals.webhooks, function(webhook) { 
    ; __append(" <li id=\"webhook_")
    ; __append(escapeFn( webhook.id ))
    ; __append("\"></li> ")
    ;  }); 
    ; __append(" ")
    ;  } 
    ; __append(" </ul> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/webhook_list.ejs
// module id = 885
// module chunks = 1